import { forwardRef, MouseEventHandler, RefObject } from 'react';
import styles from './option.scss';
import cn from 'classnames';

export interface InputOptionAttributes<Value = unknown> {
  key: string;
  disabled?: boolean;
  label: string;
  selected?: boolean;
  focused?: boolean;
  value: Value;
}
export interface InputOptionProps<T = HTMLElement> extends InputOptionAttributes {
  innerRef?: RefObject<T>;
  onMouseDown: MouseEventHandler;
  onSelect: () => void;
  onHover: () => void;
}
export const Option = forwardRef<HTMLDivElement, InputOptionProps<HTMLDivElement>>(
  ({ selected, focused, onMouseDown, onSelect, onHover, label }, ref) => (
    <div
      className={cn(styles.option, {
        [styles.selected]: selected,
        [styles.focused]: focused
      })}
      ref={ref}
      onMouseDown={onMouseDown}
      onClick={onSelect}
      onMouseEnter={onHover}
    >
      {label}
    </div>
  )
);
